import type { User as AuthUser } from "@/types";

/** Human-readable role labels - aligned with backend RBAC display names. */
const ROLE_LABELS: Record<string, string> = {
  super_admin: "Super Administrator",
  org_admin: "Organization Administrator",
  provider: "Physician / Provider",
  physician: "Physician / Provider",
  nurse: "Nurse / MA",
  medical_assistant: "Nurse / MA",
  front_desk: "Front Desk",
  billing_staff: "Billing Staff",
  cashier: "Cashier",
  accountant: "Accountant",
  patient: "Patient",
  prp_rc: "PRP Rehabilitation Counselor",
  prp_director: "PRP Program Director",
};

export function getUserRoleLabel(role?: string): string {
  if (!role) return "Team Member";
  return ROLE_LABELS[role] ?? role.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

export function getUserDisplayName(user: AuthUser | null | undefined): string {
  if (!user) return "Unknown User";
  const fullName = [user.first_name, user.last_name].filter(Boolean).join(" ").trim();
  if (user.role === "physician" || user.role === "provider") {
    return user.last_name ? `Dr. ${user.last_name}` : fullName || user.email;
  }
  return fullName || user.email;
}

export function getUserInitials(user: AuthUser | null | undefined): string {
  if (!user) return "?";
  const first = user.first_name?.[0] ?? "";
  const last = user.last_name?.[0] ?? "";
  const initials = `${first}${last}`.toUpperCase();
  return initials || user.email?.[0]?.toUpperCase() || "?";
}
